import { updateObjectInChildArrayAndRefreshCount } from "../utils/dbUtils";
import { auth } from "../firebase";
import { isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import moment from 'moment-timezone';
import { toSubmittedAtDate } from '../utils/dateFormatter';
import { v4 as uuid } from 'uuid';
import Encounter from "./Encounter";

class EncounterForm {
    id = uuid();
    userId = null;

    surveyId = null;
    answers = [];

    submittedAt = null; // only set the value if the form is completed moment().utc().toDate()

    createdBy = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    createdAt = moment().utc().toDate();
    modifiedBy = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    modifiedAt = moment().utc().toDate();

    constructor(encounterForm) {
        if (isObjectNotEmpty(encounterForm)) {
            if (isStringNotEmpty(encounterForm.id)) { this.id = encounterForm.id; }
            if (isStringNotEmpty(encounterForm.userId)) { this.userId = encounterForm.userId; }

            if (isStringNotEmpty(encounterForm.surveyId)) { this.surveyId = encounterForm.surveyId; }
            if (isListNotEmpty(encounterForm.answers)) { this.answers = encounterForm.answers; }

            // the checkout callable rasterises a client Timestamp into a { seconds, nanoseconds } map,
            // which nothing can order - coerce it back on receipt
            if (isNotNullOrUndefined(encounterForm.submittedAt)) { this.submittedAt = toSubmittedAtDate(encounterForm.submittedAt); }

            if (isStringNotEmpty(encounterForm.createdBy)) { this.createdBy = encounterForm.createdBy; }
            if (isNotNullOrUndefined(encounterForm.createdAt)) { this.createdAt = encounterForm.createdAt; }
            if (isStringNotEmpty(encounterForm.modifiedBy)) { this.modifiedBy = encounterForm.modifiedBy; }
            if (isNotNullOrUndefined(encounterForm.modifiedAt)) { this.modifiedAt = encounterForm.modifiedAt; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            userId: this.userId,

            surveyId: this.surveyId,
            answers: this.answers,

            submittedAt: this.submittedAt,

            createdAt: this.createdAt,
            createdBy: this.createdBy,
            modifiedAt: this.modifiedAt,
            modifiedBy: this.modifiedBy
        };
    }

    static create = async (encounterId, formId, newForm) => {
        const newObj = new EncounterForm({
            id: formId,
            ...newForm,
            createdAt: moment().utc().toDate(),
            createdBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM',
            modifiedAt: moment().utc().toDate(),
            modifiedBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM'
        });
        const success = await updateObjectInChildArrayAndRefreshCount(Encounter.collectionName, encounterId, 'forms', 'id', newObj.toDto(), 'formsCount');
        if (isBooleanTrue(success)) {
            return newObj.toDto();
        }

        return null;
    }

    static update = async (encounterId, formId, updatedForm) => {
        const updatedObj = new EncounterForm({
            id: formId,
            ...updatedForm,
            modifiedAt: moment().utc().toDate(),
            modifiedBy: isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM'
        });
        if (formId === updatedForm.id) {
            const success = await updateObjectInChildArrayAndRefreshCount(Encounter.collectionName, encounterId, 'forms', 'id', updatedObj.toDto(), 'formsCount');
            if (isBooleanTrue(success)) {
                return updatedObj.toDto();
            }
        } else {
            throw new Error('id and id field of the updated form must match.')
        }

        return null;
    }
};

export default EncounterForm;